(async () => {
  if (!customElements.get('product-stock-notification')) {
    class ProductStockNotification extends HTMLElement {
      constructor() {
        super();

        this.statusWrapper = this.querySelector('.product-stock-notification__status');
        this.formElement = this.querySelector('[data-notify-form]');
        this.inputElement = this.querySelector('[data-notify-input]');
        this.inputInvalidAttribute = 'aria-invalid';
        this.successElement = this.querySelector('[data-notify-success]');
        this.successElementIsOpenClass = 'product-stock-notification__success--is-open';
        this.submitBtn = this.querySelector('[type="submit"]');
        this.isSubmittingClass = 'loading';

        this.submitBtn.addEventListener('click', async (event) => {
          event.preventDefault();
          if (await this.createOrUpdateClientProfile()) {
            await this.subscribeToBackInStock();
          }
        });

        this.inputElement.addEventListener('input', this.clearInputValidation.bind(this));
      }

      async createOrUpdateClientProfile() {
        const email = this.inputElement.value.trim();
        const marketLocale = this.dataset.shopifyMarketLocale;
        const emailRegEx = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

        if (!emailRegEx.test(email)) {
          this.inputElement.setAttribute(this.inputInvalidAttribute, true);
          return false;
        }

        const endpoint = `https://a.klaviyo.com/client/profiles/?company_id=${this.dataset.klaviyoId}`;
        try {
          this.submitBtn.classList.add(this.isSubmittingClass);
          this.submitBtn.disabled = true;

          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              revision: '2024-02-15',
            },
            body: JSON.stringify({
              data: {
                type: 'profile',
                attributes: {
                  email,
                  properties: {
                    shopify_market_locale: marketLocale,
                  },
                },
              },
            }),
          });

          if (response.status !== 202) {
            throw new Error(response.status);
          }
          return true;
        } catch (error) {
          console.error('error updating customer profile', error);
          return false;
        }
      }

      async subscribeToBackInStock() {
        const variantID = document.querySelector('.product-stock-notification').dataset.variantId;

        if (!variantID) {
          this.statusWrapper.textContent = 'Invalid variant ID';
          throw new Error('Variant ID empty');
        }

        const endpoint = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.dataset.klaviyoId}`;
        try {
          this.submitBtn.classList.add(this.isSubmittingClass);
          this.submitBtn.disabled = true;

          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              revision: '2023-10-15',
            },
            body: JSON.stringify({
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  channels: ['EMAIL'],
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: this.inputElement.value.trim(),
                      },
                    },
                  },
                },
                relationships: {
                  variant: {
                    data: {
                      type: 'catalog-variant',
                      id: `$shopify:::$default:::${variantID}`,
                    },
                  },
                },
              },
            }),
          });

          if (response.status !== 202) {
            throw new Error(response.status);
          }
          this.toggleSuccessMessage(true);
        } catch (error) {
          console.error('error submitting to back in stock', error);
        } finally {
          this.submitBtn.classList.remove(this.isSubmittingClass);
          this.submitBtn.disabled = false;
        }
      }

      toggleSuccessMessage(isSuccess = true) {
        if (isSuccess) {
          this.formElement.classList.add('hidden');
          this.successElement.classList.remove('hidden');
        } else {
          this.formElement.classList.remove('hidden');
          this.successElement.classList.add('hidden');
        }
      }

      clearSubmit() {
        this.formElement.classList.remove('hidden');
        this.successElement.classList.add('hidden');
      }

      clearInputValidation() {
        if (this.inputElement.getAttribute(this.inputInvalidAttribute) === 'true') {
          this.inputElement.removeAttribute(this.inputInvalidAttribute);
        }
      }
    }

    window.ProductStockNotification = ProductStockNotification;
    customElements.define('product-stock-notification', ProductStockNotification);
  }
})();
